export const GET_ENVIRONMENTS_REQUEST = 'GET_ENVIRONMENTS_REQUEST';
export const GET_ENVIRONMENTS_SUCCESS = 'GET_ENVIRONMENTS_SUCCESS';
export const GET_ENVIRONMENTS_ERROR = 'GET_ENVIRONMENTS_ERROR';
export const UPDATE_CUSTOMER_SETTINGS_REQUEST = 'UPDATE_CUSTOMER_SETTINGS_REQUEST';
export const GET_ENVIRONMENT_FLOW_RUNS_REQUEST = 'GET_ENVIRONMENT_FLOW_RUNS_REQUEST';
export const GET_ENVIRONMENT_FLOW_RUNS_SUCCESS = 'GET_ENVIRONMENT_FLOW_RUNS_SUCCESS';
